import { useRef } from 'react';
import isEqual from 'lodash/isEqual';

export default function useDeepCompareMemoize(value) {
  const ref = useRef();

  if (value !== ref.current && !isEqual(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
}
